















import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { User } from '@/models/user';
import Users from '@/components/users/Users.vue';

@Component
export default class GrowthCycles extends Vue {
  @State('currentFarm') private currentFarmState: any;

  private activeTab = '/growth_cycles/';

    private tabs = [
        {
            id: 1,
            name: 'Growth Cycles',
            route: '/growth_cycles/',
        },
    ];
}
